module.exports = __webpack_public_path__ + "static/media/apple-touch-icon.94e27b36.png";